export enum DialogType {
  VenueSelector = 'venueSelector',
}
